module.exports = __webpack_public_path__ + "img/WaterYouDoingConceptArt2_1650x1275.ce1f93b3.jpg";